import formMapper from "@mappers/Modules/partner/PartnerItem.mapper";
import createItemAPI from "@services/Partner/createItem";
import Create from "@shared/FormTemplates/Create";
import validator from "@validators/Modules/partner/partner.validate";
import { ReactElement } from "react";
import CreateForm from "./CreateForm";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
